module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"columns":{"name":"Name","type":"Type","desc":"Windows","version":"Version"}},"zh-CHS":{"columns":{"name":"名称","type":"类型","desc":"描述","version":"版本"}}}')
  delete Component.options._Ctor
}
